import { html } from "common-tags"

export function parseVSCode(
  description: string,
  tabTrigger: string,
  snippet: string,
  scope?: string
) {
  const separatedSnippet = snippet
    .replace(/\\(?![btnr])/g, "\\\\")
    .replace(/"/g, '\\"')
    .replace(/\$/g, "\\\\$")
    .split("\n")
  const separatedSnippetLength = separatedSnippet.length

  const newSnippet = separatedSnippet.map((line, index) => {
    return index === separatedSnippetLength - 1 ? `"${line}"` : `"${line}",`
  })

  const scopeField = scope ? ` "scope": "${scope}",` : ""
  return html`
    "${description}": { "prefix": "${tabTrigger}",${scopeField} "body": [
    ${newSnippet.join("\n")} ], "description": "${description}" }
  `
}
